/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

import type { BackOfficeCardStatusDtoV1, CardCategory } from '@api/swagger/definitions/backoffice/models'
import type { PaymentOrderV2Page } from '@mynt/backoffice-api-spec/payment'
import { type QueryClient, type UseQueryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getTransactionsV2ConstEnum } from '../../helpers/ProcessHandler'
import type { BackOfficeEnfucePayoutStateV3, BackOfficePayoutPatchDtoV3 } from '../../types/payoutV3'
import {
  activatePlastic,
  addPaymentToWhiteList,
  bureau,
  bureauAssign,
  bureauClients,
  bureauConfigure,
  bureauList,
  bureauReset,
  bureauUnassign,
  cancelDirectDebitMandateV4,
  createAccountingAccount,
  createAccountingYear,
  createAgreementV8,
  createCustomer,
  createDirectDebitMandateV4,
  createEnfucePayoutUsingPOST,
  createInvoice,
  createNote,
  createPaymentRequest,
  createPersonUsingPOST,
  createSmsTemplate,
  deleteAccountingAccount,
  deleteAccountingYear,
  deleteCustomerFile,
  deleteNote,
  deletePersonUsingDELETE,
  deleteSmsTemplate,
  editAccountingYear,
  findCustomerUsingGET2,
  getAccountingAccounts,
  getAccountingYears,
  getActivationGuide,
  getActivationVisibility,
  getAllAgreementsV8,
  getAllEnfucePayoutsV3,
  getAllVouchers,
  getCardAudit,
  getCardCreditsUsingGET,
  getCardDeliveryAddress,
  getCardsV2,
  getCardTokens,
  getCustomerCardAccounts,
  getCustomerFiles,
  getCustomerLog,
  getCustomerNotes,
  getDefaultPenaltyFee,
  getDirectDebitMandatesV4,
  getEndOfDayStatements,
  getGermanDistrictCourtCodes,
  getInvoiceAuditLog,
  getInvoiceConfig,
  getInvoicesV2,
  getOrCreateCardBalanceConfigUsingGET,
  getPayment,
  getPaymentOrders,
  getPaymentReceiver,
  getPaymentRequests,
  getPaymentsUsingGET,
  getPaymentWhitelist,
  getPEReports,
  getPeopleByCustomerId,
  getPreferredMandateV4,
  getPrivateCustomerCard,
  getPrivateCustomerCardConfig,
  getPrivateCustomerCardPlastics,
  getRefreshAddress,
  getSignatories,
  getSmsTemplates,
  getTransactions,
  getVoucherResult,
  markPaymentOrderAmlApproved,
  patchActivationVisibility,
  patchCard,
  patchCardBalanceConfigUsingPATCH,
  patchCardConfig,
  patchCardCreditUsingPATCH,
  patchCardV1,
  patchEnfucePayoutV3,
  patchInvoiceConfig,
  patchPaymentRequest,
  patchPaymentUsingPATCH,
  recalculatePaumentRequests,
  registerExternalRepayment,
  reissueCard,
  removePaymentToWhiteList,
  resendDirectDebitMandateV4,
  resetCardPin,
  search,
  searchCreditApplicationsUsingGET,
  sendWelcomeEmail,
  syncCards,
  syncDirectDebitMandateV4,
  syncScoringFile,
  updateAccountingAccount,
  updateCustomer,
  updateCustomerCardAccount,
  updateInvoice,
  updateNote,
  updatePersonUsingPATCH,
  updateSmsTemplate,
  uploadScoringFile,
} from '..'
import type {
  AccountDto,
  AccountXYear,
  ActivationGuidePatchDto,
  BackOfficeAccountPatchDto,
  BackOfficeAgreementCreationDtoV8,
  BackOfficeAgreementTypeV8,
  BackOfficeCardCreditPatchV2Dto,
  BackOfficeCreatePaymentForCustomerRequestDto,
  BackOfficeCustomerCreateDtoV2,
  BackOfficeCustomerDtoV2,
  BackofficeInvoicingConfigPatchDto,
  BureauConfigRequest,
  BureauRelationshipRequest,
  BureauUnassingmentRequest,
  CardBalanceConfigPatchDto,
  CreateDirectDebitMandateV4Request,
  CreatePaymentRequestDtoV2,
  CreatePersonDto,
  FileContext,
  PatchPaymentRequestDtoV2,
  PatchStandardResourceBody,
  PaymentState,
  PersonPatchDto,
  ResetRequest,
} from '../swagger/definitions/backoffice'
import { OPTIONS } from './config'
import { useCreateListItemMutation } from './hooks/useCreateListItemMutation'
import { useDeleteListItemMutation } from './hooks/useDeleteListItemMutation'
import useMutationWithInvalidation from './hooks/useMutationWithInvalidation'
import { usePatchListItemMutation, usePatchListItemMutationOpportunistic } from './hooks/usePatchListItemMutation'
import { usePatchMutation, usePatchMutationOppertunistic } from './hooks/usePatchMutation'
import type { ObjectWithId } from './interfaces/mynt'
import {
  ACCOUNTING_ACCOUNTS,
  ACCOUNTING_YEARS,
  ACTIVATION_GUIDE,
  ACTIVATION_GUIDE_VISIBILITY,
  ADD_PAYMENT_WHITELIST,
  ALL_AGREEMENTS,
  All_VOUCHERS,
  AUTOGIRO,
  BUREAU,
  BUREAU_ASSIGN,
  BUREAU_CLIENTS,
  BUREAU_LIST,
  BUREAU_UNASSIGN,
  CARD_ACCOUNT,
  CARD_ACCOUNTS,
  CARD_CONFIG,
  CARD_CREDITS,
  CARD_TOKENS,
  CARDS,
  CARDS_AUDIT,
  CARDS_V2,
  CREATE_CUSTOMER,
  CREDIT_APPLICATIONS,
  CUSTOMER_FILES,
  CUSTOMER_LOG,
  CUSTOMER_NOTES,
  CUSTOMER_V2,
  END_OF_DAY_STATEMENTS,
  GERMAN_DISTRICT_COURTS,
  GET_AUTO_GIRO_APPROVAL,
  GET_DELIVERY_ADDRESS,
  GET_ENFUCE_PAYOUTS,
  GET_MANDATES_APPROVAL,
  GET_PAYMENT,
  GET_PAYMENT_RECEIVER,
  GET_PAYMENTS,
  GET_PERSONS,
  GET_TRANSACTIONS,
  GET_TRANSACTIONS_ACTIVATION_STATUS,
  INVOICE_AUDIT,
  INVOICE_CONFIG,
  INVOICES,
  PAYMENT_ORDERS,
  PAYMENT_REQUESTS,
  PAYMENT_WHITELIST,
  PE_REPORTS,
  PENALTY_FEE,
  PLASTICS,
  PRIVATE_CARDS,
  PRIVATE_CARDS_ID_IN_PAYLOAD,
  REFRESH_ADDRESS,
  SEARCH,
  SEND_WELCOME_EMAIL,
  SIGNATORIES,
  SMS_TEMPLATES,
  VOUCHER_RESULT,
} from './keys'

export type VoucherQueryParams = {
  from?: string
  to?: string
  years?: string[]
  accounts?: number[]
}

export type SmsBody = {
  title: string
  text: string
  rev: number
}

// The sms template is just an object type, missing its actual types
export type SmsTemplate = SmsBody & {
  createdAt: number
  deleted: boolean
  id: string
  modifiedAt: number
}

const ALL = 'all'

/**
 * The query flags callers of these hooks may override. Typed narrowly rather than as `any`,
 * because spreading an `any` into `useQuery({ ... })` turns the whole options object into
 * `any` and erases the data type inferred from `queryFn`. Plain types rather than a `Pick`
 * of `UseQueryOptions`, whose function forms of `retry` and `refetchOnWindowFocus` are
 * generic over the query's data and clash with what `queryFn` infers.
 */
type QueryOverrides = {
  enabled?: boolean
  refetchOnWindowFocus?: boolean
  retry?: boolean | number
  retryOnMount?: boolean
}

export const InvalidateStarterGuide = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({
    queryKey: [ACTIVATION_GUIDE],
  })
}

// Verify Payment
export const usePayment = (paymentId: string | undefined, options?: QueryOverrides) =>
  useQuery({
    queryKey: [GET_PAYMENT, paymentId],
    queryFn: () => getPayment(paymentId as string),
    ...options,
  })
export const usePaymentReceiver = (paymentId: string | undefined, options?: QueryOverrides) =>
  useQuery({
    queryKey: [GET_PAYMENT_RECEIVER, paymentId],
    queryFn: () => getPaymentReceiver(paymentId as string),
    ...options,
  })
export const usePaymentWhitelist = (customerId: string, options?: QueryOverrides) =>
  useQuery({
    queryKey: [PAYMENT_WHITELIST, customerId],
    queryFn: () => getPaymentWhitelist(customerId as string),
    ...options,
  })
export const useAddPaymentToWhitelist = () =>
  useMutationWithInvalidation(
    { queryKey: [ADD_PAYMENT_WHITELIST] },
    ({ paymentId }: { paymentId: string }) => addPaymentToWhiteList(paymentId as string),
    [GET_PAYMENTS],
  )
export const useRemovePaymentWhitelist = (customerId: string) =>
  useMutationWithInvalidation(
    { queryKey: [PAYMENT_WHITELIST, customerId] },
    ({ paymentId }: { paymentId: string }) => removePaymentToWhiteList(customerId, paymentId as string),
    [PAYMENT_WHITELIST],
  )

// Customers
export const useCustomer = (customerId: string, options?: QueryOverrides) =>
  useQuery({
    queryKey: [CUSTOMER_V2, customerId],
    queryFn: async () => findCustomerUsingGET2(customerId),
    ...options,
    enabled: Boolean(customerId),
    ...OPTIONS,
  })
export const useCreateCustomer = () =>
  useMutationWithInvalidation({ queryKey: [CREATE_CUSTOMER] }, async (customerDto: BackOfficeCustomerCreateDtoV2) =>
    createCustomer(customerDto),
  )
export const useGermanDistrictCourts = (options?: QueryOverrides) =>
  useQuery({
    queryKey: [GERMAN_DISTRICT_COURTS],
    queryFn: async () => getGermanDistrictCourtCodes(),
    ...options,
  })
export const usePatchCustomer = (customerId: string) =>
  usePatchMutationOppertunistic({ queryKey: [CUSTOMER_V2, customerId] }, async (dto: Partial<BackOfficeCustomerDtoV2>) =>
    updateCustomer(customerId, dto),
  )
export const useRefreshAddress = (customerId: string) =>
  useMutationWithInvalidation({ queryKey: [REFRESH_ADDRESS, customerId] }, async () => getRefreshAddress(customerId), [
    CUSTOMER_V2,
    REFRESH_ADDRESS,
  ])
export const useSendWelcomeEmail = (customerId: string) =>
  useMutationWithInvalidation({ queryKey: [SEND_WELCOME_EMAIL, customerId] }, async () => sendWelcomeEmail(customerId))
export const useCustomerEvents = (customerId: string, options?: { enabled: boolean }) =>
  useQuery({
    queryKey: [CUSTOMER_LOG, customerId],
    queryFn: async () => getCustomerLog(customerId),
    ...options,
  })
export const useCustomerNotes = (customerId: string, options?: { enabled: boolean }) =>
  useQuery({
    queryKey: [CUSTOMER_NOTES, customerId],
    queryFn: async () => getCustomerNotes(customerId),
    ...options,
  })
export const useCreateCustomerNote = (customerId: string) =>
  useCreateListItemMutation({ queryKey: [CUSTOMER_NOTES, customerId] }, async (note: string) => createNote(customerId, note))
export const useDeleteCustomerNote = (customerId: string) =>
  useMutationWithInvalidation({ queryKey: [CUSTOMER_NOTES, customerId] }, async (noteId: string) => deleteNote(customerId, noteId), [
    CUSTOMER_NOTES,
  ])
export const useUpdateCustomerNote = (customerId: string) =>
  usePatchListItemMutation(
    {
      queryKey: [CUSTOMER_NOTES, customerId],
      getId: (item) => item.id as string,
    },
    async ({ id, text, rev }: { id: string; rev: number; text: string }) => updateNote(customerId, id, text, rev),
    [CUSTOMER_NOTES],
  )

// bureau
export const useBureaus = () => {
  return useQuery({
    queryKey: [BUREAU_LIST],
    queryFn: () => bureauList(),
  })
}
export const useBureau = (bureauId: string) => {
  return useQuery({
    queryKey: [BUREAU, bureauId],
    queryFn: () => bureau(bureauId),
  })
}

export const useAssignBureau = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [BUREAU_ASSIGN],
    mutationFn: (payload: BureauRelationshipRequest) => bureauAssign(payload),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [BUREAU_CLIENTS] })
    },
  })
}

export const useUnassignBureau = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [BUREAU_UNASSIGN],
    mutationFn: (payload: BureauUnassingmentRequest) => bureauUnassign(payload),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [BUREAU_CLIENTS] })
    },
  })
}

export const useConfigureBureau = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [BUREAU],
    mutationFn: (payload: BureauConfigRequest) => bureauConfigure(payload),
    onSettled: (response) => {
      queryClient.invalidateQueries({ queryKey: [BUREAU_LIST] })
      queryClient.invalidateQueries({ queryKey: [BUREAU, response?.bureauId] })
    },
  })
}

export const useResetBureau = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [BUREAU_LIST],
    mutationFn: (payload: ResetRequest) => bureauReset(payload),
    onSettled: (response) => {
      queryClient.invalidateQueries({ queryKey: [BUREAU_LIST] })
      queryClient.invalidateQueries({ queryKey: [BUREAU, response?.bureauId] })
    },
  })
}

export const useBureauClients = (bureauId: string) => {
  return useQuery({
    queryKey: [BUREAU_CLIENTS, bureauId],
    queryFn: () => bureauClients(bureauId),
  })
}

// Transactions
export const useTransactionsV2 = (
  customerId: string,
  { offset, limit, query, cardIds, personIds, from, to }: Parameters<typeof getTransactionsV2ConstEnum>[1] = {},
) =>
  useQuery({
    queryKey: [GET_TRANSACTIONS, customerId, offset, limit, query, cardIds, personIds, from, to],

    queryFn: async () =>
      getTransactionsV2ConstEnum(customerId, {
        offset,
        limit,
        query,
        cardIds,
        personIds,
        from,
        to,
      }),

    staleTime: Infinity,
    refetchOnWindowFocus: true,
  })
export const useTransactions = (
  customerId: string,
  { page, offset, limit }: { page?: number; offset?: number; limit?: number } = {},
  options: QueryOverrides = {},
) =>
  useQuery({
    queryKey: [GET_TRANSACTIONS_ACTIVATION_STATUS, customerId],

    queryFn: async () =>
      getTransactions(customerId, {
        page,
        offset,
        limit,
      }),

    ...options,
  })

// Cards
export const usePatchCardV1 = (customerId: string, cardId: string) =>
  usePatchListItemMutation(
    { queryKey: [CARDS_V2, customerId], getId: (item) => item.id },
    async (
      payload: Partial<{
        singleAmountLimit: number
        dailySumAmount: number
        personId: string
        category: CardCategory
        status: BackOfficeCardStatusDtoV1
      }>,
    ) => patchCardV1(customerId, cardId, payload),
    [PLASTICS, PRIVATE_CARDS, CARDS_V2],
  )
export const useCardsV2 = (customerId: string, options: QueryOverrides = {}) =>
  useQuery({
    queryKey: [CARDS_V2, customerId],
    queryFn: async () => getCardsV2(customerId),
    ...options,
  })
export const useCardDeliveryAdress = (customerId?: string, personId?: string) =>
  useQuery({
    queryKey: [GET_DELIVERY_ADDRESS, customerId, personId],
    queryFn: async () => getCardDeliveryAddress(customerId as string, personId as string),
    enabled: !!customerId && !!personId,
  })
export const useCardBalanceConfig = (customerId: string) =>
  useQuery({
    queryKey: [AUTOGIRO, customerId],
    queryFn: async () => getOrCreateCardBalanceConfigUsingGET(customerId),
  })
export const useCreateCardBalanceConfig = (customerId: string) =>
  usePatchMutation({ queryKey: [AUTOGIRO, customerId] }, async (req: CardBalanceConfigPatchDto) =>
    patchCardBalanceConfigUsingPATCH(req, customerId),
  )

export const usePrivateCustomerCard = (customerId: string, cardId: string) =>
  useQuery({
    queryKey: [PRIVATE_CARDS, customerId, cardId],
    queryFn: async () => getPrivateCustomerCard(customerId, cardId),
  })
export const usePrivateCustomerCardPlastics = (customerId: string, cardId: string) =>
  useQuery({
    queryKey: [PLASTICS, customerId],
    queryFn: async () => getPrivateCustomerCardPlastics(customerId, cardId),
  })
export const usePrivateCustomerCardConfig = (customerId: string, cardId?: string) =>
  useQuery({
    queryKey: [CARD_CONFIG, customerId],
    queryFn: async () => getPrivateCustomerCardConfig(customerId, cardId as string),
    enabled: Boolean(cardId),
  })
export const usePatchCardConfig = (customerId: string, cardId: string) =>
  usePatchMutation({ queryKey: [CARD_CONFIG, customerId] }, async (config: Record<string, unknown> | any) =>
    patchCardConfig(customerId, cardId, config),
  )
export const useReissueCard = (customerId: string) =>
  useMutationWithInvalidation({ queryKey: [PRIVATE_CARDS, customerId] }, async (cardId: string) => reissueCard(customerId, cardId), [
    PRIVATE_CARDS,
  ])
export const useResetCardPin = (customerId: string) =>
  useMutationWithInvalidation({ queryKey: [PRIVATE_CARDS, customerId] }, async (cardId: string) => resetCardPin(customerId, cardId), [
    PRIVATE_CARDS,
  ])
export const usePatchCard = (customerId: string, cardId: string) =>
  useMutationWithInvalidation(
    { queryKey: [PRIVATE_CARDS, cardId, customerId] },
    async (req: PatchStandardResourceBody) => patchCard(customerId, cardId, req),
    [PRIVATE_CARDS],
  )
export const usePatchCardIdInPayload = (customerId: string) =>
  useMutationWithInvalidation(
    { queryKey: [PRIVATE_CARDS_ID_IN_PAYLOAD, customerId] },
    async ({ id, ...req }: PatchStandardResourceBody & { id: string }) => patchCard(customerId, id, req),
  )

export const usePatchCardCredit = (customerId: string) =>
  usePatchListItemMutationOpportunistic(
    {
      queryKey: [CARD_CREDITS, customerId],
      getId: (item) => item.id,
      getIdOppertunistic: (item) => item.creditId,
    },
    async ({ creditId, ...body }: BackOfficeCardCreditPatchV2Dto & { creditId: string }) =>
      patchCardCreditUsingPATCH(customerId, creditId, body),
  )
export const useCardCredits = (customerId: string, options: QueryOverrides = {}) =>
  useQuery({
    queryKey: [CARD_CREDITS, customerId],
    queryFn: async () => getCardCreditsUsingGET(customerId),
    ...OPTIONS,
    ...options,
  })
export const useCreditApplications = (customerId: string, options: QueryOverrides = {}) =>
  useQuery({
    queryKey: [CREDIT_APPLICATIONS, customerId],
    queryFn: async () => searchCreditApplicationsUsingGET(customerId),
    ...OPTIONS,
    ...options,
    enabled: Boolean(customerId),
  })
export const useActivatePlastic = (customerId: string) =>
  useMutationWithInvalidation(
    { queryKey: [PLASTICS, customerId] },
    async ({ cardId, plasticId }: { cardId: string; plasticId: string }) => activatePlastic(customerId, cardId, plasticId),
    [PLASTICS],
  )
export const useSyncCards = (customerId: string) =>
  useMutationWithInvalidation({ queryKey: [CARDS] }, async (cardId: string) => syncCards(customerId, cardId), [CARDS])
export const useCardAuditLog = (customerId: string, cardId: string) =>
  useQuery({
    queryKey: [CARDS_AUDIT, customerId, cardId],
    queryFn: async () => getCardAudit(customerId, cardId),
  })
export const useCardTokens = (customerId: string, cardId: string) =>
  useQuery({
    queryKey: [CARD_TOKENS, customerId, cardId],
    queryFn: async () => getCardTokens(customerId, cardId),
  })

// Card account
export const useUpdateCustomerCardAccount = (customerId: string) =>
  usePatchListItemMutation(
    { queryKey: [CARD_ACCOUNT, customerId], getId: (item) => item.id },
    async ({
      status,
      id,
    }: BackOfficeAccountPatchDto & {
      id: string
    }) => updateCustomerCardAccount(customerId, id, { status }),
  )
export const useCustomerCardAccounts = (customerId: string, options: QueryOverrides = {}) =>
  useQuery({
    queryKey: [CARD_ACCOUNTS, customerId],
    queryFn: async () => getCustomerCardAccounts(customerId),
    ...OPTIONS,
    ...options,
  })

// Accounting
export const useAccountingYears = (options?: QueryOverrides) =>
  useQuery({
    queryKey: [ACCOUNTING_YEARS],
    queryFn: async () => getAccountingYears() as Promise<AccountXYear[]>,
    ...options,
  })
export const useAccountingAccounts = (year?: string, options?: QueryOverrides) =>
  useQuery({
    queryKey: [ACCOUNTING_ACCOUNTS, year],
    queryFn: async () => getAccountingAccounts(year),
    ...options,
  })
export const useCreateAccountingYear = () =>
  useCreateListItemMutation({ queryKey: [ACCOUNTING_YEARS] }, async (yearDto: AccountXYear) => createAccountingYear(yearDto))
export const useUpdateAccountingYear = (id: string) =>
  usePatchListItemMutation(
    {
      queryKey: [ACCOUNTING_YEARS, id],
      getId: (item) => item.id as string,
    },
    async (yearDto: AccountXYear) => editAccountingYear(id, yearDto),
  )
export const useCreateAccountingAccount = () =>
  useCreateListItemMutation({ queryKey: [ACCOUNTING_ACCOUNTS] }, async (accountDto: AccountDto) => createAccountingAccount(accountDto))
export const useUpdateAccountingAccount = (id: string) =>
  usePatchListItemMutation(
    {
      queryKey: [ACCOUNTING_ACCOUNTS, id],
      getId: (item) => item.id as string,
    },
    async (accountDto: AccountDto) => updateAccountingAccount(id, accountDto),
  )
export const useDeleteAccountingAccount = () =>
  useMutationWithInvalidation({ queryKey: [ACCOUNTING_ACCOUNTS] }, async ({ id }: { id: string }) => deleteAccountingAccount(id), [
    ACCOUNTING_ACCOUNTS,
  ])
export const useDeleteAccountingYear = () =>
  useMutationWithInvalidation({ queryKey: [ACCOUNTING_YEARS] }, async (id: string) => deleteAccountingYear(id), [ACCOUNTING_YEARS])
export const useVoucherResult = ({ from, to, years, accounts }: VoucherQueryParams = {}, options?: QueryOverrides) =>
  useQuery({
    queryKey: [VOUCHER_RESULT, from, to, years, accounts],
    queryFn: async () => getVoucherResult(from, to, years, accounts),
    ...options,
  })
export const useAllVouchers = ({ from, to, years, accounts }: VoucherQueryParams = {}, options?: QueryOverrides) =>
  useQuery({
    queryKey: [All_VOUCHERS, from, to, years, accounts],
    queryFn: async () => getAllVouchers(from, to, years, accounts),
    ...options,
  })

// Payment Requests
export const useCreatePaymentRequest = () =>
  useCreateListItemMutation({ queryKey: [PAYMENT_REQUESTS] }, async (req: CreatePaymentRequestDtoV2) => createPaymentRequest(req))
export const usePaymentRequests = (
  customerId: string | undefined,
  filters: Parameters<typeof getPaymentRequests>[1],
  options?: QueryOverrides,
) =>
  useQuery({
    queryKey: [PAYMENT_REQUESTS, customerId, filters],
    queryFn: async () => getPaymentRequests(customerId, filters, options),
  })
export const usePatchPaymentRequests = () =>
  usePatchListItemMutationOpportunistic(
    {
      queryKey: [PAYMENT_REQUESTS],
      getId: (item) => item.id,
      getIdOppertunistic: (item) => item.id,
    },
    async ({ id, ...req }: PatchPaymentRequestDtoV2 & ObjectWithId) => patchPaymentRequest(id, req),
  )
export const useRecalculatePaymentRequest = () =>
  usePatchListItemMutation(
    {
      queryKey: [PAYMENT_REQUESTS],
      getId: (item) => item.id,
    },
    async (id: string) => recalculatePaumentRequests(id),
  )

// SMS
export const useCreateSmsTemplate = () =>
  useCreateListItemMutation({ queryKey: [SMS_TEMPLATES] }, async (body: Partial<SmsBody>) => createSmsTemplate(body))
export const useDeleteSmsTemplate = () =>
  useMutationWithInvalidation({ queryKey: [SMS_TEMPLATES] }, async (id: string) => deleteSmsTemplate(id), [SMS_TEMPLATES])
export const useUpdateSmsTemplate = () =>
  usePatchListItemMutation(
    { queryKey: [SMS_TEMPLATES], getId: (item) => item.id as string },
    async ({ id, body }: { id: string; body: SmsBody }) => updateSmsTemplate(id, body),
  )
export const useSmsTemplates = () =>
  useQuery({
    queryKey: [SMS_TEMPLATES],
    queryFn: async () => getSmsTemplates(),
  })

// Invoices
export const useInvoices = (customerId?: string, filters: Parameters<typeof getInvoicesV2>[1] = {}) =>
  useQuery({
    queryKey: [INVOICES, JSON.stringify(filters) ?? ALL],
    queryFn: async () => getInvoicesV2(customerId, filters),
    refetchOnWindowFocus: false,
  })
export const useCreateInvoice = () => {
  return useMutation({
    mutationFn: async (invoice: Parameters<typeof createInvoice>[0]) => createInvoice(invoice),
  })
}

export const usePatchInvoice = () => {
  return useMutation({
    mutationFn: async (invoice: Parameters<typeof updateInvoice>[0]) => updateInvoice(invoice),
  })
}
export const useInvoiceConfig = (customerId: string) =>
  useQuery({
    queryKey: [INVOICE_CONFIG, customerId],
    queryFn: async () => getInvoiceConfig(customerId),
  })
export const useInvoiceAuditLog = (customerId: string, invoiceId: string, enabled = true) =>
  useQuery({
    queryKey: [INVOICE_AUDIT, customerId, invoiceId],
    queryFn: async () => getInvoiceAuditLog(customerId, invoiceId),
    enabled,
  })
export const usePatchInvoiceConfig = (customerId: string) =>
  usePatchMutationOppertunistic({ queryKey: [INVOICE_CONFIG, customerId] }, (payload: BackofficeInvoicingConfigPatchDto) =>
    patchInvoiceConfig(customerId, payload),
  )
// Persons
export const usePersons = (customerId: string) =>
  useQuery({
    queryKey: [GET_PERSONS, customerId],
    queryFn: async () => getPeopleByCustomerId(customerId),
    ...OPTIONS,
  })
export const useDeletePersons = (customerId: string) =>
  useMutationWithInvalidation(
    { queryKey: [GET_PERSONS, customerId] },
    async (req: { personId: string } & ObjectWithId) => deletePersonUsingDELETE(customerId, req.personId),
    [GET_PERSONS],
  )
export const usePatchPerson = (customerId: string) =>
  usePatchListItemMutationOpportunistic(
    {
      queryKey: [GET_PERSONS, customerId],
      getId: (person) => person.id as string,
      getIdOppertunistic: (payload) => payload.personId,
    },
    async ({
      personId,
      ...req
    }: PersonPatchDto & {
      personId: string
    }) => updatePersonUsingPATCH(customerId, personId, req),
  )
export const useCreatePerson = (customerId: string) =>
  useCreateListItemMutation({ queryKey: [GET_PERSONS, customerId] }, async (personDto: CreatePersonDto) =>
    createPersonUsingPOST(customerId, personDto),
  )

// Customer scoring files
export const useSyncScoringFile = (customerId: string) =>
  useMutationWithInvalidation(
    { queryKey: [CUSTOMER_FILES, customerId] },
    async ({ id, context }: { id: string; context: FileContext }) => syncScoringFile(customerId, id, context),
    [CUSTOMER_FILES],
  )
export const useUploadScoringFile = () =>
  useMutationWithInvalidation({ queryKey: [CUSTOMER_FILES] }, async ({ url, file }: { url: string; file: File }) =>
    uploadScoringFile(url, file),
  )
export const useDeleteCustomerFile = (customerId: string) =>
  useDeleteListItemMutation(
    {
      queryKey: [CUSTOMER_FILES, customerId],
      getId: (item) => item.id as string,
    },
    async (fileId: string) => deleteCustomerFile(customerId, fileId),
  )
export const useCustomerFiles = (customerId: string, contexts: string[]) =>
  useQuery({
    queryKey: [CUSTOMER_FILES, customerId, contexts],
    queryFn: async () => getCustomerFiles(customerId, contexts),
  })

// Activation guide
export const useActivationGuideVisibility = (customerId: string, { enabled }: UseQueryOptions = {}) =>
  useQuery({
    queryKey: [customerId, ACTIVATION_GUIDE_VISIBILITY],
    queryFn: async () => getActivationVisibility(customerId),
    enabled,
  })
export const usePatchActivationGuideVisibility = (customerId: string) =>
  usePatchMutationOppertunistic(
    { queryKey: [customerId, ACTIVATION_GUIDE_VISIBILITY] },
    async (activationGuidePatchDto: ActivationGuidePatchDto) => patchActivationVisibility(customerId, activationGuidePatchDto),
  )
export const useActivationGuide = (customerId: string, { enabled }: UseQueryOptions = {}) =>
  useQuery({
    queryKey: [ACTIVATION_GUIDE, customerId],
    queryFn: async () => getActivationGuide(customerId),
    enabled,
  })

// Payouts
export const useEnfucePayoutsV3 = (customerId?: string, states?: BackOfficeEnfucePayoutStateV3[]) =>
  useQuery({
    queryKey: [GET_ENFUCE_PAYOUTS, customerId],
    queryFn: async () => getAllEnfucePayoutsV3(customerId, states),
  })
export const useCreateEnfucePayout = (customerId: string) =>
  useCreateListItemMutation({ queryKey: [GET_ENFUCE_PAYOUTS, customerId] }, createEnfucePayoutUsingPOST)
export const useUpdateEnfucePayoutV3 = () =>
  usePatchListItemMutation(
    { queryKey: [GET_ENFUCE_PAYOUTS], getId: (item: any) => item.id },
    (data: { payoutId: string; payout: BackOfficePayoutPatchDtoV3 }) => patchEnfucePayoutV3(data),
  )

// Payments
export const useUpdatePayments = () =>
  usePatchListItemMutation({ queryKey: [GET_PAYMENTS], getId: (item: any) => item.id }, patchPaymentUsingPATCH)
export const usePayments = (state?: PaymentState[]) =>
  useQuery({
    queryKey: [GET_PAYMENTS, state],
    queryFn: async () => getPaymentsUsingGET(state),
  })
export const useCreateExternalPayment = (customerId: string) =>
  useMutationWithInvalidation(
    { queryKey: [INVOICES, ALL, customerId] },
    async (req: BackOfficeCreatePaymentForCustomerRequestDto) => registerExternalRepayment(req),
    [INVOICES],
  )

// Fees
export const useDefaultPenaltyFeeV2 = (customerId: string, options: QueryOverrides = {}) =>
  useQuery({
    queryKey: [PENALTY_FEE, customerId],
    queryFn: async () => getDefaultPenaltyFee(customerId),
    ...options,
  })

// Agreements
export const invalidateAgreements = async (queryClient: QueryClient) =>
  queryClient.invalidateQueries({
    queryKey: [ALL_AGREEMENTS],
  })
export const useAllAgreementsV8 = (customerId: string, agreementType: BackOfficeAgreementTypeV8[], options?: QueryOverrides) =>
  useQuery({
    queryKey: [ALL_AGREEMENTS, customerId],
    queryFn: async () => getAllAgreementsV8(customerId, agreementType),
    ...options,
  })
export const useCreateAgreementV8 = (customerId: string) =>
  useCreateListItemMutation({ queryKey: [ALL_AGREEMENTS, customerId] }, async (agreementDto: BackOfficeAgreementCreationDtoV8) =>
    createAgreementV8(customerId, agreementDto),
  )

// Signatories
export const useSignatories = (customerId: string) =>
  useQuery({
    queryKey: [SIGNATORIES, customerId],
    queryFn: async () => getSignatories(customerId),
  })

// Mandates
export const useMandateApprovalv4 = (customerId: string, options: QueryOverrides = {}) =>
  useQuery({
    queryKey: [GET_AUTO_GIRO_APPROVAL, customerId],
    queryFn: async () => getPreferredMandateV4(customerId),
    ...options,
  })
export const useDirectDebitMandatesV4 = (customerId: string, options: QueryOverrides = {}) =>
  useQuery({
    queryKey: [GET_MANDATES_APPROVAL, customerId],
    queryFn: async () => getDirectDebitMandatesV4(customerId),
    ...options,
  })
export const useCreateDirectDebitMandateV4 = (customerId: string) =>
  useMutationWithInvalidation({ queryKey: [GET_MANDATES_APPROVAL, customerId] }, async (req: CreateDirectDebitMandateV4Request) =>
    createDirectDebitMandateV4(customerId, req),
  )
export const useSyncDirectDebitMandateV4 = (customerId: string) =>
  usePatchListItemMutation(
    {
      queryKey: [GET_MANDATES_APPROVAL, customerId],
      getId: (item) => item.id as string,
    },
    async (mandateId: string) => syncDirectDebitMandateV4(customerId, mandateId),
  )
export const useCancelDirectDebitMandateV4 = (customerId: string) =>
  usePatchListItemMutation(
    {
      queryKey: [GET_AUTO_GIRO_APPROVAL, customerId],
      getId: (item) => item.id as string,
    },
    async (mandateId: string) => cancelDirectDebitMandateV4(customerId, mandateId),
  )
export const useResendDirectDebitMandateV4 = (customerId: string) =>
  usePatchListItemMutation(
    {
      queryKey: [GET_AUTO_GIRO_APPROVAL, customerId],
      getId: (item) => item.id as string,
    },
    async (mandateId: string) => resendDirectDebitMandateV4(customerId, mandateId),
  )

// Unsorted
export const useSearch = (query: string, maxRows?: number, type?: 'CUSTOMER' | 'PERSON') =>
  useQuery({
    queryKey: [SEARCH, query, maxRows],
    queryFn: async () => search(query, maxRows, type),
    enabled: !!query,
  })
export const usePEReports = (customerId: string) =>
  useQuery({
    queryKey: [PE_REPORTS, customerId],
    queryFn: async () => getPEReports(customerId),
    ...OPTIONS,
  })

export const useEndOfDayStatements = (pagination: { page: number; pageSize: number } = { page: 1, pageSize: 25 }) =>
  useQuery({
    queryKey: [END_OF_DAY_STATEMENTS, pagination.page, pagination.pageSize],
    queryFn: async () => getEndOfDayStatements(pagination),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

export const usePaymentOrders = (pagination: { page: number; pageSize: number } = { page: 1, pageSize: 25 }) =>
  useQuery({
    queryKey: [PAYMENT_ORDERS, pagination.page, pagination.pageSize],
    queryFn: async () => getPaymentOrders(pagination),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

export const useMarkPaymentOrderAmlApproved = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => markPaymentOrderAmlApproved(id),
    onSuccess: (updated) => {
      queryClient.setQueriesData<PaymentOrderV2Page>({ queryKey: [PAYMENT_ORDERS] }, (page) =>
        page ? { ...page, data: page.data.map((order) => (order.id === updated.id ? updated : order)) } : page,
      )
    },
  })
}
